module.exports = __webpack_public_path__ + "static/media/opico-logo.939c8dcf.png";